const Bowser = require('bowser/bundled');
import IEDatePicker from './components/IEDatePicker.vue';
import StandardDatePicker from './components/DatePicker.vue';

const browser = Bowser.getParser(window.navigator.userAgent);
const canLoad = browser.getBrowserName() !== 'Internet Explorer';
export const DatePicker = canLoad ? StandardDatePicker : IEDatePicker;